import { ReactNode, useContext } from 'react';
import { NOTIFICATION_CENTER_ENABLER } from 'common/constants/features/features';
import FeaturesContext from 'context/FeaturesContext';
import { useIsUserLoggedIn } from 'pages/Auth/hooks';
import AblyContextProvider from './AblyProvider';

/**
 * Mounts a single shared Ably Realtime client for the SPA session while the user is logged in
 * AND the `notification_center` feature flag is enabled.
 *
 * Keeping this inside FeaturesProvider allows the flag to gate the entire Ably connection —
 * no websocket is opened when the feature is off.
 *
 * We also mount when a JWT exists in storage but the user object is not hydrated yet; otherwise
 * routes can render Main (private + token) before `useIsUserLoggedIn` is true and hooks like
 * `useAbly` would run without an AblyProvider.
 */
const AppAblyProvider = ({ children }: { children: ReactNode }) => {
  const { features } = useContext(FeaturesContext);
  const isLoggedIn = useIsUserLoggedIn();
  const hasAccessToken = typeof globalThis.localStorage !== 'undefined' && Boolean(globalThis.localStorage.getItem('access'));
  const shouldMountAbly = (isLoggedIn || hasAccessToken) && Boolean(features[NOTIFICATION_CENTER_ENABLER]);

  if (!shouldMountAbly) {
    return <>{children}</>;
  }

  return <AblyContextProvider>{children}</AblyContextProvider>;
};

export default AppAblyProvider;
